import Resource from './Resource';

/**
 * Inspection Resource
 */
class Inspection extends Resource
{
    constructor() {
        super('vehicle.inspection', ['vehicles', 'inspections']);
    }

    reset(inspection_id) {
        return this._doPost([inspection_id, 'reset']);
    }

    complete(inspection_id, data = {}) {
        return this._doPost([inspection_id, 'complete'], data);
    }
}   

export let InspectionResource = new Inspection();

export let InspectionSchema = function(defaults = {}) {
    let schema = {
        'instance_id': null,
        'definition_id': null,
        'completed_by_id': null,
        'completed_at': null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export let DefinitionSchema = function(defaults = {}) {
    let schema = {
        'name': null,
        'handle': null,
        'type': null,
        'triggers': null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

/**
 * Answer Schema
 * @param {Object} defaults [description]
 */
export let AnswerSchema = function(defaults = {}) {
    let schema = {
        inspection_id: '',
        question_id: '',
        task_id: '',
        outcome: '',
        comments: '',
        completed_by_id: '',
        completed_at: '',
        additional_data: {},
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export const TyreStateQuestionHandle = 'tyre.state'

export let TyreStateAnswerSchema = function(defaults = {}) {
    let schema = {
        front_left: {
            outcome: '',
            comments: '',
            depth_outer: '',
            depth_centre: '',
            depth_inner: '',
            make: '',
            spec: '',
        },

        front_right: {
            outcome: '',
            comments: '',
            depth_outer: '',
            depth_centre: '',
            depth_inner: '',
            make: '',
            spec: '',
        },

        rear_left: {
            outcome: '',
            comments: '',
            depth_outer: '',
            depth_centre: '',
            depth_inner: '',
            make: '',
            spec: '',
        },

        rear_right: {
            outcome: '',
            comments: '',
            depth_outer: '',
            depth_centre: '',
            depth_inner: '',
            make: '',
            spec: '',
        },

        spare: {
            outcome: '',
            comments: '',
            depth_outer: '',
            depth_centre: '',
            depth_inner: '',
            make: '',
            spec: '',
        },
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export let BrakeStateAnswerSchema = function(defaults = {}) {
    let schema = {
        front_pads_wear_percentage: '',
        front_outcome: '',
        front_comments: '',
        rear_pads_wear_percentage: '',
        rear_outcome: '',
        rear_comments: '',
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export const DefectGroupSchema = function(defaults = {}) {
    let schema = {
        outcome: '',
        type: '',
        defects: []
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export const DefectSchema = function(defaults = {}) {
    let schema = {
        group_id: '',
        type: '',
        panel: '',
        top: 0,
        left: 0,
        comments: '',
        repair_estimate: undefined,
        task_id: '',
        completed_by_id: '',
        completed_at: '',
        images: [],
        task: undefined
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export let AnswerOutcomes = {
    OUTCOME_PASSED: 'passed',
    OUTCOME_ADVISORY: 'advisory',
    OUTCOME_FAILED: 'failed',
    OUTCOME_SKIPPED: 'skipped'
}

export let AnswerOutcomesList = [
    {label: 'Passed', value: AnswerOutcomes.OUTCOME_PASSED },
    {label: 'Advisory', value: AnswerOutcomes.OUTCOME_ADVISORY },
    {label: 'Failed', value: AnswerOutcomes.OUTCOME_FAILED }, 
    {label: 'Skipped', value: AnswerOutcomes.OUTCOME_SKIPPED }
]

export const DefectTypes = {
    PART_REPLACEMENT: 'broken_or_missing_part',
    PANEL: 'panel',
    CHIP: 'chip',
    CRACK: 'crack',
    DENT: 'dent',
    SCUFF: 'scuff',
    SCRATCH: 'scratch',
    WORN: 'worn',
    OTHER: 'other',
}

export const DefectTypeList = [
    { value: DefectTypes.PART_REPLACEMENT, label: 'Broken Or Missing Part' },
    { value: DefectTypes.CHIP, label: 'Chip', },
    { value: DefectTypes.CRACK, label: 'Crack', },
    { value: DefectTypes.DENT, label: 'Dent', },
    { value: DefectTypes.PANEL, label: 'Panel', },
    { value: DefectTypes.SCRATCH, label: 'Scratch', },
    { value: DefectTypes.SCUFF, label: 'Scuff', },
    { value: DefectTypes.WORN, label: 'Worn', },
    { value: DefectTypes.OTHER, label: 'Other' },
]

export const PanelList = [
    { value: 'Nearside - Front Wheel', label: 'Nearside - Front Wheel', },
    { value: 'Nearside - Rear Wheel', label: 'Nearside - Rear Wheel', },
    { value: 'Nearside - Front Tyre', label: 'Nearside - Front Tyre', },
    { value: 'Nearside - Rear Tyre', label: 'Nearside - Rear Tyre', },
    { value: 'Nearside - Rear Door', label: 'Nearside - Rear Door', },
    { value: 'Nearside - Front Door', label: 'Nearside - Front Door', },
    { value: 'Nearside Sill', label: 'Nearside Sill', },
    { value: 'Nearside - Rear Quarter', label: 'Nearside - Rear Quarter', },
    { value: 'Nearside - Rear Arch', label: 'Nearside - Rear Arch', },
    { value: 'Nearside - Front Arch', label: 'Nearside - Front Arch', },
    { value: 'Nearside - Wing', label: 'Nearside - Wing', },
    { value: 'Nearside - Headlight', label: 'Nearside - Headlight', },
    { value: 'Nearside - Front Pillar', label: 'Nearside - Front Pillar', },
    { value: 'Nearside - Rear Light', label: 'Nearside - Rear Light', },
    { value: 'Nearside - Rear Light', label: 'Nearside - Rear Light', },
    { value: 'Nearside - Headlight', label: 'Nearside - Headlight', },
    { value: 'Nearside - Rear Bumper', label: 'Nearside - Rear Bumper', },
    { value: 'Tailgate - Nearside', label: 'Tailgate - Nearside', },
    { value: 'Tailgate - Offside', label: 'Tailgate - Offside', },
    { value: 'Offside - Rear Bumper', label: 'Offside - Rear Bumper', },
    { value: 'Rear Glass', label: 'Rear Glass', },
    { value: 'Tailgate', label: 'Tailgate', },
    { value: 'Rear Bumper', label: 'Rear Bumper', },
    { value: 'Offside - Rear Light', label: 'Offside - Rear Light', },
    { value: 'Front Bumper - Offside', label: 'Front Bumper - Offside', },
    { value: 'Front Bumper - Nearside', label: 'Front Bumper - Nearside', },
    { value: 'Bonnet - Nearside', label: 'Bonnet - Nearside', },
    { value: 'Windscreen - Nearside', label: 'Windscreen - Nearside', },
    { value: 'Bonnet - Offside', label: 'Bonnet - Offside', },
    { value: 'Windscreen - Offside', label: 'Windscreen - Offside', },
    { value: 'Windscreen', label: 'Windscreen', },
    { value: 'Front Bumper', label: 'Front Bumper', },
    { value: 'Bonnet', label: 'Bonnet', },
    { value: 'Roof - Nearside', label: 'Roof - Nearside', },
    { value: 'Roof - Offside', label: 'Roof - Offside', },
    { value: 'Roof', label: 'Roof', },
    { value: 'Offside - Front Wheel', label: 'Offside - Front Wheel', },
    { value: 'Offside - Rear Wheel', label: 'Offside - Rear Wheel', },
    { value: 'Offside - Front Tyre', label: 'Offside - Front Tyre', },
    { value: 'Offside - Rear Tyre', label: 'Offside - Rear Tyre', },
    { value: 'Offside - Wing Mirror', label: 'Offside - Wing Mirror', },
    { value: 'Offside - Front Arch', label: 'Offside - Front Arch', },
    { value: 'Offside - Rear Arch', label: 'Offside - Rear Arch', },
    { value: 'Offside - Rear Quarter', label: 'Offside - Rear Quarter', },
    { value: 'Offside - Rear Door', label: 'Offside - Rear Door', },
    { value: 'Offside - Front Door', label: 'Offside - Front Door', },
    { value: 'Offside - Wing', label: 'Offside - Wing', },
    { value: 'Offside - Sill', label: 'Offside - Sill', },
    { value: 'Offside - Headlight', label: 'Offside - Headlight', },
    { value: 'Offside - Front Pillar', label: 'Offside - Front Pillar', },
    { value: 'Offside - Rear Light', label: 'Offside - Rear Light', },
    { value: 'Offside - Headlight', label: 'Offside - Headlight', },
]